import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

enum LOGOUT_SERVICES {
  LogoutResolver,
}

export type LogoutServices = keyof typeof LOGOUT_SERVICES

export const LOGOUT_SERVICE_TYPES = makeServicesTypesFromEnum<LogoutServices>(LOGOUT_SERVICES)
